import { EventEmitter, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";

import {
  ViewService,
  SearchParams,
  TsdfCode,
  TsdfCodeService,
  CheckboxRenderer,
  CheckboxEditor,
  DeleteRowRenderer,
  AddRowHeader,
  ListViewDelegate,
  capitalizeFirstLetter,
} from "../common";

@Component({
  selector: "tsdfcodes-view",
  templateUrl: "./auxiliarylist-view.html",
  standalone: false,
})
export class TsdfCodesView implements ListViewDelegate<TsdfCode> {
  errorMsg: string;
  public refresh: EventEmitter<void> = new EventEmitter<void>();
  public entity: TsdfCode;
  public sourceColumns;
  public sourceComponents;
  gridKeyColumn: string = "code";

  constructor(
    public route: ActivatedRoute,
    public viewService: ViewService,
    public dataService: TsdfCodeService
  ) {
    viewService.setViewData({
      pageTitle: "TSDF Codes",
      link: {},
      breadcrumbs: false,
    });
    this.sourceComponents = {
      chkBoxRenderer: CheckboxRenderer,
      chkBoxEditor: CheckboxEditor,
      deleteRow: DeleteRowRenderer,
      addRow: AddRowHeader,
    };
    this.sourceColumns = [
      {
        headerComponent: "addRow",
        headerComponentParams: { selectColumn: this.gridKeyColumn },
        cellRenderer: "deleteRow",
        minWidth: 100,
        sortable: false,
        filter: false,
        editable: false,
      },
      {
        headerName: capitalizeFirstLetter(this.gridKeyColumn),
        field: this.gridKeyColumn,
        minWidth: 100,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Description",
        field: "description",
        minWidth: 500,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Disposal Method",
        field: "disposalMethod",
        minWidth: 200,
        filter: "agTextColumnFilter",
        sortingOrder: ["asc", "desc"],
      },
      {
        headerName: "Active",
        field: "active",
        minWidth: 100,
        filter: false,
        sortingOrder: ["asc", "desc"],
        cellRenderer: "chkBoxRenderer",
        cellEditor: "chkBoxEditor",
      },
    ];
  }

  performSearch(searchParams: SearchParams): Observable<TsdfCode[]> {
    return this.dataService.all(searchParams);
  }

  save(entity: TsdfCode) {
    this.dataService.save(entity).subscribe(
      (en) => {
        this.errorMsg = null;
        this.refreshView();
      },
      (error) => {
        this.errorMsg = error;
        this.refreshView();
      }
    );
  }

  remove(entity: TsdfCode) {
    if (window.confirm(`Are you sure you want to remove '${entity[this.gridKeyColumn]}'?`)) {
      this.dataService.remove(entity.id).subscribe((x) => {
        this.errorMsg = null;
        this.refreshView();
      });
    }
  }

  refreshView() {
    this.refresh.emit();
  }
}
